import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';


function PowerInstrumentation() {
    const [active, setActive] = useState("Safe Area");
    const navigate = useNavigate();
    return (
        <>
         <Helmet>
                <title>
                    Power & Instrumentation Cables UAE | Control & Fibre Optic Cables
                </title>

                <meta
                    name="description"
                    content="Al Ibtekar supplies power, instrumentation, control, data, thermocouple, fibre optic, armoured, rubber flexible and fire performance cables for industrial applications across the UAE."
                />

                <meta
                    name="keywords"
                    content="power cables UAE, instrumentation cables UAE, control cables UAE, thermocouple cables UAE, fibre optic cables UAE, data cables UAE, armoured cables UAE, H07RN-F cables UAE, fire performance cables UAE, electrical cables supplier UAE, industrial cables UAE"
                />

                <meta
                    name="robots"
                    content="index, follow"
                />

                <link
                    rel="canonical"
                    href="https://saig.me/PowerInstrumentation"
                />

                <meta
                    property="og:title"
                    content="Power & Instrumentation Cables UAE | Al Ibtekar"
                />

                <meta
                    property="og:description"
                    content="Explore power, instrumentation, control, data, thermocouple, fibre optic, armoured and fire performance cables from Al Ibtekar for industrial applications in the UAE."
                />

                <meta
                    property="og:url"
                    content="https://saig.me/PowerInstrumentation"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:site_name"
                    content="Al Ibtekar"
                />

                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="Power & Instrumentation Cables UAE | Al Ibtekar"
                />

                <meta
                    name="twitter:description"
                    content="Power, instrumentation, control, data, thermocouple and fibre optic cables for industrial applications across the UAE."
                />
            </Helmet>
            {/* <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.8 }}
                className="mt-[91px] overflow-hidden relative"
            >
                <motion.img
                    initial={{ scale: 1.2 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 1.2, ease: 'easeOut' }}
                    src="/assets/service/bg3.png"
                    className="w-full lg:h-auto h-[300px] object-cover"
                    alt="	Trusted cable management and termination solutions provider in the UAE"
                />
                <div className="absolute lg:top-[125px] top-[20px] max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] left-1/2 -translate-x-1/2">
                    <motion.h6
                        initial={{ opacity: 0, y: 40 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.3, duration: 0.7 }}
                        className="font-[500] font-kanit lg:text-[70px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]"
                    >
                        Cables
                    </motion.h6>
                    <motion.p
                        initial={{ opacity: 0, x: -30 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: 0.5, duration: 0.7 }}
                        className="max-w-[582px] w-full font-[300] font-inter text-[20px] leading-[30px] text-[#FFFFFF]"
                    >
                        High-performance cables for power, control, and signal transmission.
                    </motion.p>
                </div>
                <motion.h1
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.6, duration: 0.8 }}
                    className="absolute font-[600] font-kanit lg:text-[180px] text-[60px] lg:leading-[180px] leading-[70px] text-[#FFFFFF4F] right-[0px] lg:bottom-[86px] bottom-[40px]"
                >
                    Instrumentation
                </motion.h1>
            </motion.div> */}


               <div className='newbanner-about newbanner-about3'>
      <div className="max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">
        <h6 className="font-[500] font-kanit lg:text-[60px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]">Cables</h6>
        <p className="w-full font-[300] font-inter lg:text-[20px] text-[12px] lg:leading-[30px] leading-[16px] text-[#FFFFFF]">High-performance cables for power, control, and signal transmission.
        </p>
      </div>
      </div>
       <div className='newbg'>

               <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] overflow-hidden allheader mb-[20px]'>
  {/* <h2>Junction Box & Enclosures - Safe Area</h2>
  <div className='line'></div> */}
<h2>Cables</h2>
  <div className='line'></div>
                         <h3 className='text-left mb-[20px]'>A comprehensive range of multi-brand cables are available in accordance with some of the most exacting standards in the world, including British Standards (BS), CSA, IEC, VDE and UL. The portfolio includes power, instrumentation, data, control, thermocouple, fibre optics and fire performance cables</h3>


               </div>
               </div>
            <div className='detail-div max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] pb-[0px]'>

                <div className='detail-div-left'>
                    {/* <div className='side-img'>

        <img src='/assets/s.jpg'/>
        <img src='/assets/s.jpg'/>
        <img src='/assets/s.jpg'/>

        </div> */}
                    <div className='main-img'>

                        <img src='/assets/apip2.png' />
                    </div>


                </div>
                

                <div className='detail-div-right service-details-div2-new '>

                 <div className="service-heading">
                        <span className="dot">●</span>
                        <h4>Armoured Cables (SWA & AWA)  </h4>
                      </div>
                      <p> Low Voltage (0.6/1kV) and Medium Voltage (6.35/11kV & 19/33kV) power cables</p>
                    
                     
                      <div className="service-heading">
                        <span className="dot">●</span>
                        <h4>
Earthing Cables</h4>
                      </div>
                      <p>
                   Designed for use on earthing circuits with outer sheath in Green/Yellow (power) and Green (instrumentation) applications </p>
                    
                      <div className="service-heading">
                        <span className="dot">●</span>
                        <h4>Rubber Flexible Cables (H07RN-F)  </h4>
                      </div>
                      <p> Heavy-duty rubber flexible cables designed to provide high flexibility during usage</p>
                    
                      <div className="service-heading">
                        <span className="dot">●</span>
                        <h4>
Instrumentation Cables</h4>
                      </div>
                      <p>
                  Primarily used for transmitting signals that monitor and control various processes, available as per BS EN 50288-7</p>
                    
                      <div className="service-heading">
                        <span className="dot">●</span>
                        <h4>Control Cables</h4>
                      </div>
                      <p>
                       Highly flexible multicore cables for measuring, control or regulation used for process automation, including CY & SY cables</p>
                    
                      <div className="service-heading">
                        <span className="dot">●</span>
                        <h4>Data Cables  </h4>
                      </div>
                      <p>Also known as ethernet cables, designed to transmit information and data between devices in the form of electrical signals</p>
                       <div className="service-heading">
                        <span className="dot">●</span>
                        <h4>Thermocouple Cables </h4>
                      </div>
                      <p>
                   Composed of two wires made of dissimilar metals to transmit temperature readings from a thermocouple probe to a temperature measuring device </p>
                       <div className="service-heading">
                        <span className="dot">●</span>
                        <h4>Fibre Optic Cables </h4>
                      </div>
                      <p>
                     Network cables that transmit data as light/optical signals through glass or plastic fibers, offering high bandwidth, long distance and EMI resistance  </p>
                         <div className="service-heading">
                        <span className="dot">●</span>
                        <h4>Fire Performance Cables </h4>
                      </div>
                      <p>
                  Designed to maintain circuit integrity and continue functioning in case of fire, used in fire alarm, emergency lighting and sounders </p>
             
                </div>
            </div>
            <br/>
               <div className='newbg'>

               <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] overflow-hidden allheader mb-[20px]'>

                         <h3 className='text-left mb-[20px]'>Cables can be customised with regards to sheath material PVC/LSZH; Anti-termite & Anti-rodent version, core colours, core marking, outer jacket colours, fire resistance, flame resistance, voltage ratings, performance standards, international & regional standards</h3>

<Link to="/product">
                       <button className="backbtn mt-6">
                         Back To Products
                       </button>
                     </Link>
               </div>
               </div>

            <br />
            <br />
        </>
    )
}

export default PowerInstrumentation